<app-header [registration]="true"></app-header>
<div class="backgroundGrey">
  <mat-stepper (selectionChange)="onSelectionChange()" labelPosition="right" linear #stepper>
    <mat-step [stepControl]="firstFormGroup">
      <ng-template matStepLabel>
        <p class="stepperLabel">
          {{ 'registration.steps.one' | translate}}
        </p>
      </ng-template>
      <p *ngIf="isMobile" class="body3Ligth">{{'registration.header' | translate}}</p>
      <app-step-one></app-step-one>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup">
      <ng-template matStepLabel>
        <p class="stepperLabel">
          {{ 'registration.steps.two' | translate}}
        </p>
      </ng-template>
      <p *ngIf="isMobile" class="body3Ligth">{{'registration.header' | translate}}</p>
      <app-step-two></app-step-two>
    </mat-step>
    <mat-step [stepControl]="thirdFormGroup">
      <ng-template matStepLabel>
        <p class="stepperLabel">
          {{ 'registration.steps.three' | translate}}
        </p>
      </ng-template>
      <p *ngIf="isMobile" class="body3Ligth">{{'registration.header' | translate}}</p>
      <app-step-three></app-step-three>
    </mat-step>
    <mat-step [stepControl]="fourthFormGroup">
      <ng-template matStepLabel>
        <p class="stepperLabel">
          {{ 'registration.steps.four' | translate}}
        </p>
      </ng-template>
      <p *ngIf="isMobile" class="body3Ligth">{{'registration.header' | translate}}</p>
      <app-step-four></app-step-four>
    </mat-step>
  </mat-stepper>
</div>